import React from 'react';

// UI/UX POLISH: Enhanced card component with better visual design
const EnhancedCard = ({ 
  children, 
  className = '', 
  hover = true,
  padding = 'lg',
  shadow = 'md',
  rounded = 'xl',
  background = 'default',
  animation = 'fade-in',
  onClick,
  ...props 
}) => {
  const paddingClasses = {
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
    xl: 'p-8'
  };

  const shadowClasses = {
    none: 'shadow-none',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  };

  const roundedClasses = {
    sm: 'rounded-lg',
    md: 'rounded-xl',
    lg: 'rounded-2xl',
    xl: 'rounded-3xl'
  };

  const backgroundClasses = {
    default: 'bg-white/90 backdrop-blur-sm',
    solid: 'bg-white',
    glass: 'bg-white/60 backdrop-blur-md',
    gradient: 'bg-gradient-to-br from-white/95 to-white/85 backdrop-blur-sm'
  };

  const baseClasses = [
    'border border-gray-200/60',
    paddingClasses[padding],
    shadowClasses[shadow],
    roundedClasses[rounded],
    backgroundClasses[background],
    'transition-all duration-300 ease-out',
    animation
  ];

  if (hover) {
    baseClasses.push('hover:shadow-xl hover:-translate-y-1 hover:border-gray-300/60');
  }

  if (onClick) {
    baseClasses.push('cursor-pointer select-none');
  }

  return (
    <div
      className={`${baseClasses.join(' ')} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default EnhancedCard;
